import React from 'react';
import { Box } from '@mui/material';
import LottoPosTile from '../../LottoPosTile';
import SummaryTile from '../../SummaryTile';
import { ManualAmountInput } from '../components/ManualAmountInput';
import { TileCheckbox } from '../components/TileCheckbox';
import type { TileConfig } from '../types';

export function ScratcherSalesTile({
  config,
  isLoading,
  isAllShift,
  posInputValue,
  secondaryPosInputValue,
  onPosInputChange,
  onSecondaryPosInputChange,
  localVerified,
  localAck,
  onRequestDialog,
}: {
  config: TileConfig;
  isLoading: boolean;
  isAllShift: boolean;
  posInputValue: string;
  secondaryPosInputValue: string;
  onPosInputChange: (nextValue: string) => void;
  onSecondaryPosInputChange: (nextValue: string) => void;
  localVerified: boolean;
  localAck: boolean;
  onRequestDialog: (args: { mode: 'verify' | 'ack'; nextVerified: boolean; nextAck: boolean }) => void;
}) {
  if (!config.visible) return null;

  const shouldShowAction = config.variant !== 'standard_lotto_pos' || config.badge !== 'MATCHED';
  const hideAction = Boolean(config.hideAction);

  const action =
    config.actionLabel && shouldShowAction && !hideAction ? (
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <TileCheckbox
            isAllShift={isAllShift}
            label={config.actionLabel}
            localVerified={localVerified}
            localAck={localAck}
            onRequestDialog={onRequestDialog}
          />
        </Box>
      </Box>
    ) : null;

  if (config.variant === 'standard_lotto_pos') {
    return (
      <LottoPosTile
        title={config.title}
        badge={config.badge}
        value={config.value}
        subtext={config.subtext}
        footer={config.footer}
        isLoading={isLoading}
        cardClassName={config.cardClassName}
        containerSx={config.containerSx}
        extraContent={
          config.inputPlaceholder ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, width: '100%' }}>
              <ManualAmountInput
                ariaLabel="Scratcher POS Sales"
                value={posInputValue}
                onChange={onPosInputChange}
                disabled={false}
                placeholder={config.inputPlaceholder}
                width={150}
              />
              <ManualAmountInput
                ariaLabel="Scratcher POS Qty"
                value={secondaryPosInputValue}
                onChange={onSecondaryPosInputChange}
                disabled={false}
                placeholder="Enter POS QTY"
                width={150}
              />
            </Box>
          ) : undefined
        }
      >
        {action}
      </LottoPosTile>
    );
  }

  return (
    <SummaryTile
      title={config.title}
      value={config.value || ''}
      subtext={config.subtext}
      footer={config.footer}
      isLoading={isLoading}
      className={config.className}
      valueClassName={config.valueClassName}
      cardClassName={config.cardClassName}
      containerSx={config.containerSx}
    >
      {action}
    </SummaryTile>
  );
}

